function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD6C9",
  d: "M88.962 69.003l-36.91-63.43a.193.193 0 00-.166-.095h-8.08a.19.19 0 00-.166.095L6.73 69.003a1.587 1.587 0 00-.216.798v10.796c0 .107.086.193.192.193h82.472V69.801c0-.28-.075-.556-.216-.798"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF4134",
  d: "M12 75.377v-4.37a.19.19 0 01.026-.096l34.823-59.844a.19.19 0 01.166-.095h1.919c.068 0 .131.036.166.095L83.923 70.91c.017.03.026.063.026.097v4.37a.192.192 0 01-.192.192H12.192a.191.191 0 01-.192-.192"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  d: "M56.228 39.086a7.543 7.543 0 10.001 15.087 7.543 7.543 0 00-.001-15.087m-.171 5.486c1.229 0 2.228 1 2.228 2.228 0 1.229-1 2.229-2.228 2.229-1.229 0-2.229-1-2.229-2.229s1-2.228 2.229-2.228m-12.661-.264l-5.407 5.406h-2.136v-2.136l5.407-5.406h2.136z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  d: "M35.853 44.308l5.407 5.406h2.136v-2.136l-5.407-5.406h-2.136zm10.261 14.321a4.286 4.286 0 100 8.572 4.286 4.286 0 000-8.572m0 2.743c.85 0 1.543.692 1.543 1.542 0 .851-.692 1.543-1.543 1.543-.85 0-1.543-.692-1.543-1.543 0-.85.692-1.542 1.543-1.542"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AA133D",
  d: "M21.372 80.79v9.75H18.12v-9.75h3.252zm56.13 0v9.75H74.25v-9.75h3.253z"
}));

const SvgSignalError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96
}, props), _ref);

export default SvgSignalError;